module.exports = __webpack_public_path__ + "static/peaceloverun-03978cfb4a2068b13c0c887675bd6e4d.png";